const isZendeskActive = () => typeof window.zE === "function";

let isHidden = false;

export const openMessenger = () => {
  if (isHidden) return;
  if (isZendeskActive()) {
    window.zE?.("messenger", "open");
  }
};

export const showMessenger = () => {
  isHidden = false;
  if (isZendeskActive()) {
    window.zE?.("messenger", "show");
  }
};

export const hideMessenger = () => {
  isHidden = true;
  if (isZendeskActive()) {
    window.zE?.("messenger", "hide");
  }
};

export const trackMessengerEvent = (
  eventName: string,
  eventData: Record<string, any> = {}
) => {
  if (isZendeskActive()) {
    const fields = [
      { id: "last_event", value: eventName },
      { id: "last_event_data", value: JSON.stringify(eventData) },
      { id: "last_event_timestamp", value: new Date().toISOString() },
    ];
    window.zE?.("messenger:set", "conversationFields", fields);
  }
};
